import { CustomBreadcrumb, PageContent } from "components/Common";
import { ModuleIds } from "constant";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import TestTab from "./TestTab";

const RESOURCE = ModuleIds.Test;

const TestsContainer = ({ t }) => {
    const titleTag = `Test`
    return (
        <PageContent title={t(titleTag)}>
            < CustomBreadcrumb
                breadcrumbItem={t("Test List")}
                resource={RESOURCE}
            />
            <TestTab />
        </PageContent >
    )
}

TestsContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["testPage"])(TestsContainer)